import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import type { ChargeWithInvoice, DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency } from '../dashboard-utils';

@Component({
  selector: 'app-dash-upcoming-overdue',
  templateUrl: './dash-upcoming-overdue.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterLink],
  styles: [':host { display: block; height: 100%; }']
})
export class DashUpcomingOverdueWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly formatCurrency = formatDashboardCurrency;

  trackCharge(_: number, c: ChargeWithInvoice): number {
    return c.id ?? 0;
  }
}
